/* eslint-disable no-nested-ternary */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { connect } from 'react-redux';
import appActions from 'redux/app/actions';
import { Layout } from 'antd';
import { compose } from 'redux';
import { MenuOutlined } from '@ant-design/icons';
import { withRouter } from 'react-router-dom';
import TopbarWrapper from './topbar.style';
import Logo from '../../utility/logo';

const { Header } = Layout;

const Topbar = (props) => {
  const {
    openDrawer,
    history,
    toggleOpenDrawer,
    role,
    title,
    subtitle,
    children,
    breadcrumbs,
    justifyChildren = 'flex-end',
    style = {},
  } = props;
  const sidebar = role !== 'AccountAgent';
  const styling = {
    background: 'white',
    position: 'fixed',
    left: 0,
    width: '100%',
    height: 77,
    transform: 'translateY(-90%)',
  };

  return (
    <TopbarWrapper style={style}>
      <Header
        style={styling}
        className={
          sidebar
            ? !openDrawer
              ? 'isomorphicTopbar collapsed'
              : 'isomorphicTopbar'
            : 'isomorphicTopbar noSidebar'
        }
      >
        <div className="isoLeft">
          {sidebar ? (
            <button
              className={
                !openDrawer ? 'triggerBtn menuCollapsed' : 'triggerBtn menuOpen'
              }
              style={{ color: 'black' }}
              onClick={toggleOpenDrawer}
            ><MenuOutlined style={{ fontSize: '18px'}}/>
            </button>
          ) : (
            <div className="logoWrap">
              <Logo />
            </div>
          )}
          <h2 className="title" data-testid="topbar-title">
            {breadcrumbs
              && breadcrumbs.map(({ title, href }) => (
                <a
                  key={title}
                  href={href}
                  onClick={(e) => {
                    e.preventDefault();
                    history.push(href);
                  }}
                >
                  {title}
                </a>
              ))}
            <span className="topbar-head-title" >{title}</span>
            {subtitle && <small>{subtitle}</small>}
          </h2>
        </div>
        <div
          style={{ display: 'flex', width: '100%', justifyContent: justifyChildren }}
          className="children"
        >
          {children}
        </div>
        <ul className="isoRight" />
      </Header>
    </TopbarWrapper>
  );
};

export default compose(
  withRouter,
  connect(
    (state) => ({
      openDrawer: state.App.openDrawer,
      profile: state.Profile,
    }),
    { ...appActions },
  ),
)(Topbar);
